// product-sticky-cta.js — Pattern #9 lifecycle on the THRUX product page,
// plus mobile-specific direct-add-to-cart behavior.
//
// Visibility lifecycle (both viewports):
//   - Mobile (<768px): visible immediately on load (2026-08-28 change; the
//     mobile fold otherwise shows no price/CTA to paid traffic).
//   - Desktop: hidden initially, becomes visible when product hero section's
//     bottom passes above 50% of viewport height (RAF-throttled scroll listener).
//   - Suppressed when section 08 / Grab a Can enters viewport — handled in
//     thrux-scroll-reveal.js via a separate IntersectionObserver.
//
// Mobile (<768px) behavior additions:
//   - Label reads "Add to cart — $XX.XX" with the price mirrored from the
//     hero buy box's [data-buy-box-cta-price] element. JS observes the
//     hero buy box's CTA price and updates the sticky on every tier change.
//   - Tap scrolls to the hero buy box (same as desktop; changed 2026-08-28
//     from programmatic add-to-cart, which blind-added the default flavor).
//
// Desktop (≥768px) behavior unchanged:
//   - Label reads "Buy THRUX →".
//   - Tap is the native anchor → #thrux-buy-box-hero (scrolls to buy box).

(function () {
  'use strict';

  function init() {
    var cta = document.querySelector('.product-sticky-cta');
    var hero = document.querySelector('[data-section-type="product-hero"]');
    if (!cta || !hero) return;

    var ticking = false;

    function measure() {
      var rect = hero.getBoundingClientRect();
      // Mobile: sticky visible from load (paid-traffic fold has no price/CTA
      // otherwise; decided 2026-08-28). Desktop keeps the scroll gate.
      var alwaysOnMobile = window.matchMedia('(max-width: 767px)').matches;
      var heroBottomAboveMidline = rect.bottom <= window.innerHeight * 0.5;
      if (alwaysOnMobile || heroBottomAboveMidline) {
        cta.classList.add('is-visible');
      } else {
        cta.classList.remove('is-visible');
      }
      ticking = false;
    }

    function onScrollOrResize() {
      if (!ticking) {
        requestAnimationFrame(measure);
        ticking = true;
      }
    }

    // Suppress while the HERO buy box or the FOOTER is on screen
    // (2026-08-28): the sticky's job is only the dead zones where no real
    // CTA/footer content is visible. Same class+CSS pattern as
    // --suppressed-by-final (that one lives in thrux-scroll-reveal.js).
    if ('IntersectionObserver' in window) {
      var buyBox = document.querySelector('[data-buy-box][data-instance="hero"]');
      if (buyBox) {
        new IntersectionObserver(function (entries) {
          cta.classList.toggle('product-sticky-cta--suppressed-by-buybox', entries[0].isIntersecting);
        }, { threshold: 0.05 }).observe(buyBox);
      }
      var pageFooter = document.querySelector('footer');
      if (pageFooter) {
        new IntersectionObserver(function (entries) {
          cta.classList.toggle('product-sticky-cta--suppressed-by-footer', entries[0].isIntersecting);
        }, { threshold: 0.05 }).observe(pageFooter);
      }
    }

    measure();
    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize, { passive: true });
    window.addEventListener('orientationchange', onScrollOrResize, { passive: true });

    // --- Price mirror (mobile label) ---
    // Watch the hero buy box's CTA price text; mirror into the sticky's
    // data-sticky-price span. MutationObserver covers tier changes
    // (product-page.js mutates [data-buy-box-cta-price].textContent on
    // each tier click).
    var stickyPriceEls = cta.querySelectorAll('[data-sticky-price], [data-sticky-price-desktop]');
    var heroPriceEl = document.querySelector(
      '[data-buy-box][data-instance="hero"] [data-buy-box-cta-price]'
    );
    if (stickyPriceEls.length && heroPriceEl) {
      var sync = function () {
        var txt = heroPriceEl.textContent.trim();
        stickyPriceEls.forEach(function (el) { el.textContent = txt; });
      };
      sync();
      var pricePoller = new MutationObserver(sync);
      pricePoller.observe(heroPriceEl, { childList: true, characterData: true, subtree: true });
    }

    // --- Mobile tap → submit hero form ---
    cta.addEventListener('click', function (e) {
      // Desktop: keep native anchor behavior. Mobile: intercept and
      // programmatically click the hero buy box CTA button so the existing
      // product-page.js add-to-cart flow runs (loading state, cart:update,
      // drawer auto-open).
      // 2026-08-28: mobile no longer auto-adds to cart (blind default-flavor
      // adds + zero on-bar feedback felt broken). All viewports now use the
      // native anchor -> smooth-scroll to #thrux-buy-box-hero where flavor,
      // tier and the real CTA live.

      if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true && typeof window.gtag === 'function') {
        window.gtag('event', 'product_sticky_cta_click', {
          cta_location: 'sticky_product_page',
          viewport: window.innerWidth < 768 ? 'mobile' : 'desktop',
        });
      }
      window.dispatchEvent(new CustomEvent('thrux:product_sticky_click', {
        detail: {
          cta_location: 'sticky_product_page',
          viewport: window.innerWidth < 768 ? 'mobile' : 'desktop',
        }
      }));
    });
  }


  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
